export default __webpack_public_path__ + "static/media/main.906eadb3.jpg";